var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19141",
    "data-name": "Path 19141",
    d: "M6,19H3a1,1,0,0,1-1-1V8A1,1,0,0,1,3,7H6V3A1,1,0,0,1,7,2H17a1,1,0,0,1,1,1V7h3a1,1,0,0,1,1,1V18a1,1,0,0,1-1,1H18v2a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1Zm0-2V16a1,1,0,0,1,1-1H17a1,1,0,0,1,1,1v1h2V9H4v8ZM8,4V7h8V4ZM8,17v3h8V17ZM5,10H8v2H5Z",
    transform: "translate(-2 -2)",
    fill: "#dcb209"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.e1232532ed6e1ce01f8689cb8c8b5626.svg";
export { ForwardRef as ReactComponent };